import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription, fromEvent } from 'rxjs';
import { startWith } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-password-verification-success-popup',
  templateUrl: './password-verification-success-popup.component.html',
  styleUrls: ['./password-verification-success-popup.component.scss']
})
export class PasswordVerificationSuccessPopupComponent implements OnInit, OnDestroy {
  isLoading = false;
  isMobile = false;
  logoPath = 'assets/images/edu-logo.svg';
  resizeObservable$: Subscription | undefined;

  constructor(private readonly router: Router) { }

  ngOnInit(): void {
   this.setupResponsiveImage();
    setTimeout(() => {
      
      this.isLoading = true;
      
      
      setTimeout(() => {
        this.router.navigate(['/login']);
      }, 3000);
    }, 2000);
  }

   ngOnDestroy(): void {
    if (this.resizeObservable$) {
      this.resizeObservable$.unsubscribe();
    }
  }

     setupResponsiveImage(): void {
        this.resizeObservable$ = fromEvent(window, 'resize').pipe(startWith({} as Event))
          .subscribe(() => {
            this.isMobile = window.innerWidth < 768;
            this.updateLogoPath();
          });
        
        this.isMobile = window.innerWidth < 768;
        this.updateLogoPath();
      }

          updateLogoPath(): void {
    this.logoPath = this.isMobile 
      ? 'assets/images/cardy-ai/mobile-logo.svg'
      : 'assets/images/edu-logo.svg';
  }
}
